import { render, staticRenderFns } from "./ItineraryHeaderSection.vue?vue&type=template&id=3547c502&scoped=true&"
import script from "./ItineraryHeaderSection.vue?vue&type=script&lang=js&"
export * from "./ItineraryHeaderSection.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryHeaderSection.vue?vue&type=style&index=0&id=3547c502&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3547c502",
  null
  
)

export default component.exports